<template>
    <div>
        <div class="tabs is-boxed">
            <ul>
                <router-link :to="{ name: 'client-kra-payments' }" active-class="is-active" tag="li"><a>Payments</a></router-link>
            </ul>
        </div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "client-kra"
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/kra/index.vue